<router-outlet></router-outlet>
<p-toast position="bottom-center" [preventOpenDuplicates]="true"></p-toast>
